import { useContext } from "react";
import { OperationContext } from './../components/OperationComponent/Operation/OperationDetail/index';

export const useOperationHook = () => {
    // get the context
    const context = useContext(OperationContext);
    // if `undefined`, throw an error
    if (!context ) {
        throw new Error("OperationContext was used outside of its Provider");
    }
    return context;
};